import React from 'react';
import Spring from '@/components/Spring';
import styles from './styles.module.scss';
import classNames from 'classnames';

export interface LeaderboardRowData {
  name: string;
  color?: string;
  pts?: number;
  score?: number;
  w?: number;
  d?: number;
  l?: number;
}

interface LeaderboardRowProps {
  data: LeaderboardRowData;
  index: number;
  variant?: 'minimal' | 'league';
}

export const LeaderboardRow: React.FC<LeaderboardRowProps> = ({
  data,
  index,
  variant = 'minimal'
}) => {
  // Default to LTR direction (RTL support can be added later if needed)
  const direction = 'ltr';

  return (
    <Spring index={index} type="slideUp">
      <div
        className={classNames(
          styles.row,
          styles[direction],
          'label h6',
          { [styles.top]: index === 0 }
        )}
        data-color={data.color}
      >
        <div className={classNames(styles.info, styles[variant])}>
          {variant === 'league' && <span className={styles.index}>{index + 1}</span>}
          <span className="flex-1 text-overflow">{data.name}</span>
          {variant === 'league' && (
            <div className={styles.points}>
              <span>{data.w}</span>
              <span>{data.d}</span>
              <span>{data.l}</span>
            </div>
          )}
        </div>
        <div className={styles.total}>
          {variant === 'minimal' ? data.score : data.pts}
        </div>
      </div>
    </Spring>
  );
};

export default LeaderboardRow;
